import { Button, Loading, Modal } from '@orobix/orobix-fe-components'
import { Trans, useTranslation } from 'react-i18next'

import {
  getIsExceeded,
  getQuota,
  getRemaining,
  getStatus,
  getUsed,
} from '../../../utils/counter'
import useStyles from './StartTrainingTestConfirmationModal.styles'
import { useTrainingTestCounterData } from './useTrainingTestCounterData'

export interface StartTrainingTestConfirmationModalProps {
  onCloseRequest: () => void
  onStartTrainingTestRequest: () => void
}

const StartTrainingTestConfirmationModal = ({
  onCloseRequest,
  onStartTrainingTestRequest,
}: StartTrainingTestConfirmationModalProps) => {
  const { t } = useTranslation()
  const classes = useStyles()

  const { counter } = useTrainingTestCounterData()

  const remaining = getRemaining(counter)
  const used = getUsed(counter)
  const quota = getQuota(counter)
  const isExceeded = getIsExceeded(counter)

  const handleClick = () => {
    onCloseRequest()
    onStartTrainingTestRequest()
  }

  return (
    <Modal
      size="sm"
      onCloseRequest={onCloseRequest}
      title={t('Confirm test')}
      footer={
        counter ? (
          <>
            <Button
              onClick={onCloseRequest}
              label={t('Cancel')}
              type="default"
              buttonType="button"
            />
            <Button
              onClick={handleClick}
              label={t('Start test')}
              type="action"
              buttonType="button"
              disabled={counter.isEnabled && isExceeded}
            />
          </>
        ) : null
      }
    >
      {
        {
          allowed: (
            <Trans
              i18nKey="You have only <emph>{{ count }} test left</emph> ({{ used }} used over {{ quota }} available). Are you sure you want to proceed?"
              values={{ count: remaining, used, quota }}
              components={{ emph: <b className={classes.emph} /> }}
            />
          ),
          forbidden: t('Sorry, you reached maximum test limit.'),
          disabled: t('Great, you have unlimited tests.'),
          loading: <Loading />,
        }[getStatus(counter)]
      }
    </Modal>
  )
}

export default StartTrainingTestConfirmationModal
